import Swiper from 'swiper/bundle';
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Navigation, Pagination } from 'swiper/modules';
import { initLayout } from '../layout.js';
import { initPageHeader } from '../sections/page-header.js';


gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {
    initLayout();
    initPageHeader();
    productApplicationOverview();
    initProductApplicationListing();
})

function navigationToDetailCategoryApplication(){
    const cards = document.querySelectorAll('.card-category-application-mini');
    const customNavbar=document.querySelector('.custom-navbar');
    const breadcrumb=document.querySelector('.breadcrumb');
    if(!cards || !customNavbar || !breadcrumb) {
        console.error('Trigger Elements or customNavbar or breadcrumb not found');
    }else{
        const customNavbarHeight=customNavbar.clientHeight;
        const BreadcrumbHeight=breadcrumb.clientHeight;
        const navbarAndBreadCrumbHeight=customNavbarHeight - 10

        cards.forEach(function (card) {
            card.addEventListener('click', function () {
                 // Remove 'active' from all cards
                cards.forEach(c => c.classList.remove('active'));
                // Add 'active' to the clicked card
                card.classList.add('active');
                const target = card.getAttribute('data-target');
                gsap.to(window, {
                    duration: 0.1, // smoother scroll
                    scrollTo: {
                        y: `#${target}` ,
                        offsetY: navbarAndBreadCrumbHeight
                    },
                });
            });
        });
    }
}

function productApplicationOverview(){
    navigationToDetailCategoryApplication()
    window.addEventListener('resize',function(){
        navigationToDetailCategoryApplication()
    })
    let swiperProductOverview = new Swiper(".product-applications-overview__slider", {
        slidesPerView: 1,
        spaceBetween: 18,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 18,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        }
    });
}

function initProductApplicationListing(){
    document.querySelectorAll('.product-application').forEach((sectionProductApplicationElm, index) => {
        new Swiper(sectionProductApplicationElm.querySelector('.product-application-slider'), {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            autoHeight: true,
            pagination: {
                el: sectionProductApplicationElm.querySelector('.product-application-slider-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: sectionProductApplicationElm.querySelector('.product-application-slider-next'),
                prevEl: sectionProductApplicationElm.querySelector('.product-application-slider-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 18,
                },
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
            }
        });
    });
}

